import "../scss/style.scss";

import { headerHeight } from "./headerHeight";
import { initializeObserveAnimation } from "./fadein";
import { initializeSmoothScroll } from "./initializeScroll.js";
import * as header from "./headerNav";
import { showLoadingScreen, hideLoadingScreen } from "./load.js";
import { initializeResizeObserver } from "./resizeObserverModule.js";

// 例としての使用方法
document.addEventListener("DOMContentLoaded", () => {
  header.toggleMenu();
  const targetElements = document.querySelectorAll("[data-scroll-animation]");

  const options = {
    rootMargin: "10% 0px",
    threshold: 0.5,
  };

  initializeObserveAnimation(targetElements, options);
  headerHeight();
  initializeSmoothScroll();
  initializeResizeObserver();

  showLoadingScreen();

  setTimeout(() => {
    hideLoadingScreen();
  }, 3000);
});
